import { StarsButton } from '@ps/web-shared-components';
import React, { useContext, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import { ModalContext } from '@swf/components/StarsModal/Context';
import useOnClickOutside from '@swf/core/hooks/useOnClickOutside';
import type { Dispatch } from '@swf/core/store';
import { useWidgetTheme } from '@swf/poker';

import {
  TXTCLI_Block,
  TXTCLI_Grant_Admin,
  TXTCLI_Reinstate,
  TXTCLI_Remove,
  TXTCLI_Revoke_Admin,
  TXTCLI_Suspend
} from './ActionsModal.messages.json';
import styles from './ActionsModal.scss';

interface LocationState {
  handleClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const ActionsModal: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const {
    state: { handleClick }
  } = useLocation<LocationState>();
  const ref = useRef<HTMLDivElement>(null);
  const { setStyle } = useContext(ModalContext);
  const { className } = useWidgetTheme();

  useEffect(() => {
    setStyle({
      overlayClassName: className,
      className: styles.container,
      closeOnOverlayClick: true,
      closeOnEsc: true
    });
  }, [className, setStyle]);

  const handleAction = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    handleClick(e);
    modal.close();
  };

  useOnClickOutside(ref, () => {
    modal.close();
  });

  return (
    <div ref={ref} className={styles.innerContainer}>
      <StarsButton
        data-action="HG_BLOCK_PLAYER"
        variant="text"
        translation={TXTCLI_Block}
        onClick={handleAction}
      />
      <StarsButton
        data-action="HG_REMOVE_PLAYER"
        variant="text"
        translation={TXTCLI_Remove}
        onClick={handleAction}
      />
      <StarsButton
        data-action="HG_MAKE_PLAYER_ADMIN"
        variant="text"
        translation={TXTCLI_Grant_Admin}
        onClick={handleAction}
      />
      <StarsButton
        data-action="HG_REVOKE_PLAYER_ADMIN"
        variant="text"
        translation={TXTCLI_Revoke_Admin}
        onClick={handleAction}
      />
      <StarsButton
        data-action="HG_SUSPEND_PLAYER"
        variant="text"
        translation={TXTCLI_Suspend}
        onClick={handleAction}
      />
      <StarsButton
        data-action="HG_REINSTATE_PLAYER"
        variant="text"
        translation={TXTCLI_Reinstate}
        onClick={handleAction}
      />
    </div>
  );
};

export default ActionsModal;
